import * as React from 'react';
import cn from 'classnames';

import { IconSize } from 'shared/entities/components/Icon';
import {
  SelectorSize,
  SelectorTopItem
} from 'shared/newEntities/components/Selector';
import {
  TypographyWeight,
  TypographySize,
  TypographyType
} from 'shared/newEntities/components/Typography';
import Typography from 'shared/newComponents/Typography';

import './TopItem.modules.scss';

type Props = SelectorTopItem & {
  onClose: () => void;
  selectorSize?: SelectorSize;
  centered?: boolean;
};

const TopItem: React.FC<Props> = ({
  Icon,
  title,
  onClick,
  onClose,
  selectorSize,
  centered = true
}: Props) => {
  const handleClick = React.useCallback(() => {
    onClick(onClose);
  }, [onClick, onClose]);

  const handleMouseDown = React.useCallback((event: React.MouseEvent) => {
    event.stopPropagation();
  }, []);

  return (
    <div styleName="top-item-container" onMouseDown={handleMouseDown}>
      <div
        styleName={cn(
          'top-item',
          selectorSize === SelectorSize.small && 'top-item_small',
          centered && 'top-item_centered'
        )}
        onClick={handleClick}
      >
        {Icon && <Icon styleName="top-item__icon" iconSize={IconSize.XM} />}
        <Typography
          fontType={TypographyType.text}
          fontSize={
            selectorSize === SelectorSize.small
              ? TypographySize.s
              : TypographySize.m
          }
          fontWeight={
            selectorSize === SelectorSize.small
              ? TypographyWeight.normal
              : TypographyWeight.semiBold
          }
          fontColor={null}
        >
          {title}
        </Typography>
      </div>
    </div>
  );
};

export default React.memo(TopItem);
